import React from 'react';
import SvgIcon from '../SvgIcon';

/**
 * @ignore - internal component.
 */
function ExpandLess(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
    </SvgIcon>
  );
}

export default React.memo(ExpandLess);



// WEBPACK FOOTER //
// ./src/icons/internals/ExpandLess.jsx